import { ObjectTools } from '../../../tools/object-tools';
import { SolTooltip } from '../../../models/core/sol-tooltip';
import { SolText } from '../../../models/core/sol-text';

export class SolTooltipState {
  private constructor(public readonly tooltip: SolTooltip) {}

  public static of(): SolTooltipState {
    return new SolTooltipState(SolTooltip.of(SolText.empty()));
  }

  public withTooltip(tooltip: SolTooltip): SolTooltipState {
    return this.copy({ tooltip });
  }

  private copy(props: Partial<SolTooltipState>): SolTooltipState {
    return ObjectTools.copy<SolTooltipState>(this, props);
  }
}
